import React from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import { dateToView } from "../../../../../utils/date.utils";

const Form11 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
  dataLeaveCancel,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
  dataLeaveCancel: any;
}) => {
  // กัน "undefined undefined" เมื่อไม่มีฉายา/นามสกุล
  const buddhistFullName =
    [dataEmployee?.buddhist_name, dataEmployee?.last_name]
      .filter(Boolean)
      .join(" ") || null;

  const leave_start =
    dataLeaveCancel?.leave_peroid_date?.[0] != null
      ? dateToView(dataLeaveCancel.leave_peroid_date[0])
      : null;
  const leave_end =
    dataLeaveCancel?.leave_peroid_date?.[1] != null
      ? dateToView(dataLeaveCancel.leave_peroid_date[1])
      : null;

  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        form_code={"บค. ๒๕"}
        place_label={"สัญญาเลขที่"}
        place_value={null}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* ตามที่ข้าพเจ้า / ฉายา/นามสกุล */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ตามที่ข้าพเจ้า"}
          end_label={null}
          length={90}
          value={dataEmployee?.first_name}
          isParagraph={true}
        />
        <RenderValue
          start_label={"ฉายา/นามสกุล"}
          end_label={null}
          length={100}
          value={buddhistFullName}
          isParagraph={false}
        />
      </div>
      {/* ตำแหน่ง / แผนงาน / สังกัด */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={70}
          value={dataEmployee?.work_history?.position_name}
          isParagraph={false}
        />
        <RenderValue
          start_label={"แผนงาน"}
          end_label={null}
          length={70}
          value={dataEmployee?.department?.department_name_th}
          isParagraph={false}
        />
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={70}
          value={"IBSC"}
          isParagraph={false}
        />
      </div>
      {/* ได้รับอนุญาตให้ลา (ประเภทใบลาที่เลือกยกเลิก) ตั้งแต่วันที่ - ถึงวันที่ */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ได้รับอนุญาตให้ลา"}
          end_label={null}
          length={90}
          value={dataLeaveCancel?.leave_type_name}
          isParagraph={false}
        />
        <RenderValue
          start_label={"ตั้งแต่วันที่"}
          end_label={null}
          length={40}
          value={leave_start}
          isParagraph={false}
        />
        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={40}
          value={leave_end}
          isParagraph={false}
        />
      </div>
      {/* รวม ... วัน นั้น */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"รวม"}
          end_label={"วัน นั้น"}
          length={30}
          value={dataLeaveCancel?.leave_day}
          isParagraph={false}
          grow={false}
        />
      </div>
      {/* เนื่องจาก */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"เนื่องจาก"}
          end_label={null}
          length={230}
          value={dataReportDetail?.condition?.reason_cancel}
          isParagraph={false}
        />
      </div>
      {/* บรรทัดต่อของเหตุผล (เผื่อเขียนมือ) */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={null}
          end_label={null}
          length={250}
          value={null}
          isParagraph={false}
        />
      </div>
      {/* จึงขอยกเลิกวันลา ... จำนวน ... วัน */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"จึงขอยกเลิกวันลา"}
          end_label={null}
          length={100}
          value={dataLeaveCancel?.leave_type_name}
          isParagraph={false}
          grow={false}
        />
        <RenderValue
          start_label={"จำนวน"}
          end_label={"วัน"}
          length={30}
          value={dataLeaveCancel?.leave_day}
          isParagraph={false}
          grow={false}
        />
      </div>
      {/* ตั้งแต่วันที่ - ถึงวันที่ (ช่วงที่ยกเลิก) */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"ตั้งแต่วันที่"}
          end_label={null}
          length={50}
          value={leave_start}
          isParagraph={false}
          grow={false}
        />
        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={50}
          value={leave_end}
          isParagraph={false}
          grow={false}
        />
      </div>

      {/* signature*/}
      <div className="w-full ml-24">
        <SignaturePrint
          title={"เรียนมา/นมัสการมาด้วยความเคารพ"}
          prefix={`ลงชื่อ`}
          position={""}
          isDate={false}
          isPosition={false}
          data={{}}
        />
      </div>
      <div className="w-full">
        <CommentPrint
          title={"ความเห็นของผู้บังคับบัญชาชั้นต้น"}
          isCheckBoxApprove={false}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            isApprove: data?.leave_status
              ? data.leave_status === "approve third"
              : null,
            comment: data.leave_approve_first_comment ?? "",
          }}
          lengthDot={150}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>

        <CommentPrint
          title={"คำสั่งของผู้มีอำนาจอนุญาต"}
          isCheckBoxApprove={true}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            // ยังไม่มีสถานะ → ไม่ติ๊กช่องใดเลย (เส้นว่างเหมือนแบบฟอร์มกระดาษ)
            isApprove: data?.leave_status
              ? data.leave_status === "approve third"
              : null,
            // ผู้มีอำนาจอนุญาต = ผู้อนุมัติลำดับสาม (ตามแบบเดียวกับ Form03)
            comment: data.leave_approve_third_comment ?? "",
          }}
          lengthDot={150}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>
      </div>
    </div>
  );
};

export default Form11;
